import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnShareStatus } from '@lib/api/entities';
import { SnSize } from '@lib/common/types';

@Component({
  selector: 'sn-share-status',
  templateUrl: './share-status.component.html',
  styleUrls: ['./share-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnShareStatusComponent {
  @Input()
  public status: SnShareStatus;

  @Input()
  public size: SnSize = 'sm';

  public readonly SHARE_STATUS = SnShareStatus;

  constructor() {}
}
